import { render, staticRenderFns } from "./AddPaymentToInvoice.vue?vue&type=template&id=48495590&scoped=true&"
import script from "./AddPaymentToInvoice.vue?vue&type=script&lang=ts&"
export * from "./AddPaymentToInvoice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48495590",
  null
  
)

export default component.exports